import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ChevronRight,
  MapPin,
  Clock,
  Briefcase,
  Search,
  X,
  Filter,
} from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";

const jobs = [
  {
    title: "Senior Elektromonteur",
    location: "Amsterdam",
    type: "Fulltime",
    experience: "5+ jaar ervaring",
    category: "Elektromonteur",
    salary: "€3.500 - €4.500",
    description:
      "Als Senior Elektromonteur ben je verantwoordelijk voor complexe elektrotechnische installaties en renovaties. Je leidt projecten en begeleidt junior monteurs.",
    requirements: [
      "MBO-4 diploma Elektrotechniek",
      "VCA-VOL certificaat",
      "NEN 3140 VP certificering",
      "Minimaal 5 jaar ervaring als elektromonteur",
      "Rijbewijs B",
    ],
  },
  {
    title: "Junior Elektromonteur",
    location: "Rotterdam",
    type: "Fulltime",
    experience: "0-2 jaar ervaring",
    category: "Elektromonteur",
    salary: "€2.400 - €2.800",
    description:
      "Als Junior Elektromonteur werk je samen met ervaren collega's aan diverse elektrotechnische installaties. Je krijgt de kans om je te ontwikkelen tot een volleerd elektromonteur.",
    requirements: [
      "MBO-3/4 diploma Elektrotechniek",
      "VCA-basis certificaat",
      "Gemotiveerd om te leren",
      "Rijbewijs B",
    ],
  },
  {
    title: "Werkvoorbereider Elektrotechniek",
    location: "Utrecht",
    type: "Fulltime",
    experience: "3+ jaar ervaring",
    category: "Kantoor",
    salary: "€3.000 - €4.000",
    description:
      "Als Werkvoorbereider ben je de schakel tussen verkoop en uitvoering. Je bereidt elektrotechnische projecten voor en zorgt voor een soepele uitvoering.",
    requirements: [
      "MBO-4/HBO diploma Elektrotechniek",
      "Ervaring met AutoCAD",
      "Kennis van NEN 1010",
      "Goede communicatieve vaardigheden",
      "Projectmatig kunnen werken",
    ],
  },
  {
    title: "Service Monteur",
    location: "Den Haag",
    type: "Fulltime",
    experience: "2+ jaar ervaring",
    category: "Elektromonteur",
    salary: "€2.800 - €3.500",
    description:
      "Als Service Monteur ben je het visitekaartje van ons bedrijf. Je lost storingen op en voert onderhoud uit bij onze klanten.",
    requirements: [
      "MBO-3/4 diploma Elektrotechniek",
      "VCA certificaat",
      "Klantvriendelijk en communicatief sterk",
      "Rijbewijs B",
    ],
  },
  {
    title: "Project Manager",
    location: "Amsterdam",
    type: "Fulltime",
    experience: "5+ jaar ervaring",
    category: "Management",
    salary: "€4.500 - €5.500",
    description:
      "Als Project Manager ben je verantwoordelijk voor het succesvol uitvoeren van grote elektrotechnische projecten.",
    requirements: [
      "HBO/WO diploma",
      "Ervaring met projectmanagement",
      "Kennis van elektrotechniek",
      "Sterke leiderschapskwaliteiten",
    ],
  },
];

const locations = [
  "Alle locaties",
  "Amsterdam",
  "Rotterdam",
  "Utrecht",
  "Den Haag",
];
const categories = ["Alle functies", "Elektromonteur", "Kantoor", "Management"];
const experienceLevels = [
  "Alle ervaringsniveaus",
  "0-2 jaar",
  "2-5 jaar",
  "5+ jaar",
];

function Vacatures() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("Alle locaties");
  const [selectedCategory, setSelectedCategory] = useState("Alle functies");
  const [selectedExperience, setSelectedExperience] = useState(
    "Alle ervaringsniveaus"
  );
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);

  const filteredJobs = jobs.filter((job) => {
    const matchesSearch =
      job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesLocation =
      selectedLocation === "Alle locaties" || job.location === selectedLocation;
    const matchesCategory =
      selectedCategory === "Alle functies" || job.category === selectedCategory;
    const matchesExperience =
      selectedExperience === "Alle ervaringsniveaus" ||
      (selectedExperience === "0-2 jaar" && job.experience.includes("0-2")) ||
      (selectedExperience === "2-5 jaar" && job.experience.includes("2+")) ||
      (selectedExperience === "5+ jaar" && job.experience.includes("5+"));

    return (
      matchesSearch && matchesLocation && matchesCategory && matchesExperience
    );
  });

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedLocation("Alle locaties");
    setSelectedCategory("Alle functies");
    setSelectedExperience("Alle ervaringsniveaus");
  };

  return (
    <div className="min-h-screen bg-white page-transition mt-[99px] md:mt-[133px] pt-6">
       <SEO
        title="Werken bij elektricieninarnhem026.nl - Vacatures"
        description="Wij zijn altijd op zoek naar getalenteerde elektromonteurs en technici die ons team willen versterken. Zoek hieronder onze vacatures."
        image="/images/banner.png"
      />
      <Header />

      {/* Hero Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
          <div>
            <h1 className="flex  items-center gap-3 font-bold text-black leading-[1.25] text-[40px] lg:text-[52px] mb-4 text-[28px] md:mb-5 md:text-[44px] text-[#17354A]">
              Werken bij
              <span className="flex items-center gap-2 leading-none">
                <span className="text-3xl font-['Pacifico']">elektra</span>
                <span className="text-xl font-['Pacifico']">aanleggen</span>
              </span>
            </h1>
            <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] max-w-[720px]">
              Wij zijn altijd op zoek naar getalenteerde elektromonteurs en
              technici die ons team willen versterken.
            </div>
          </div>
          <button
            onClick={() => setIsMobileFiltersOpen(true)}
            className="md:hidden flex items-center gap-2 px-4 py-2 bg-[#F8F9FB] rounded-lg text-[#17354A] mt-4"
          >
            <Filter className="w-5 h-5" />
            Filters
          </button>
        </div>

        {/* Main Content */}
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar Filters - Desktop */}
          <div className="hidden md:block w-[300px] flex-shrink-0">
            <div className="sticky top-[133px] bg-white p-6 rounded-xl border border-[#E5E7EB]">
              <div className="space-y-6">
                {/* Search */}
                <div>
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="text"
                      placeholder="Zoek vacature..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-10 pr-4 py-2 border border-[#E5E7EB] rounded-lg focus:border-[#FFD100] focus:outline-none"
                    />
                  </div>
                </div>

                {/* Location Filter */}
                <div>
                  <h3 className="font-medium text-[#17354A] mb-2">Locatie</h3>
                  <div className="space-y-2">
                    {locations.map((location) => (
                      <label key={location} className="flex items-center">
                        <input
                          type="radio"
                          name="location"
                          value={location}
                          checked={selectedLocation === location}
                          onChange={(e) => setSelectedLocation(e.target.value)}
                          className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                        />
                        <span className="ml-2 text-[#17354A]">{location}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Category Filter */}
                <div>
                  <h3 className="font-medium text-[#17354A] mb-2">Functie</h3>
                  <div className="space-y-2">
                    {categories.map((category) => (
                      <label key={category} className="flex items-center">
                        <input
                          type="radio"
                          name="category"
                          value={category}
                          checked={selectedCategory === category}
                          onChange={(e) => setSelectedCategory(e.target.value)}
                          className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                        />
                        <span className="ml-2 text-[#17354A]">{category}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Experience Filter */}
                <div>
                  <h3 className="font-medium text-[#17354A] mb-2">Ervaring</h3>
                  <div className="space-y-2">
                    {experienceLevels.map((level) => (
                      <label key={level} className="flex items-center">
                        <input
                          type="radio"
                          name="experience"
                          value={level}
                          checked={selectedExperience === level}
                          onChange={(e) =>
                            setSelectedExperience(e.target.value)
                          }
                          className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                        />
                        <span className="ml-2 text-[#17354A]">{level}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <button
                  onClick={clearFilters}
                  className="w-full px-4 py-2 text-[#FFD100] border border-[#FFD100] rounded-lg hover:bg-[#FFD100] hover:text-white transition-colors"
                >
                  Filters wissen
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Filters */}
          {isMobileFiltersOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden">
              <div className="absolute right-0 top-0 h-full w-[300px] bg-white p-6 overflow-y-auto">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="font-bold text-[#17354A] text-lg">Filters</h2>
                  <button onClick={() => setIsMobileFiltersOpen(false)}>
                    <X className="w-6 h-6 text-[#17354A]" />
                  </button>
                </div>

                <div className="space-y-6">
                  {/* Search */}
                  <div>
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <input
                        type="text"
                        placeholder="Zoek vacature..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-[#E5E7EB] rounded-lg focus:border-[#FFD100] focus:outline-none"
                      />
                    </div>
                  </div>

                  {/* Location Filter */}
                  <div>
                    <h3 className="font-medium text-[#17354A] mb-2">Locatie</h3>
                    <div className="space-y-2">
                      {locations.map((location) => (
                        <label key={location} className="flex items-center">
                          <input
                            type="radio"
                            name="location"
                            value={location}
                            checked={selectedLocation === location}
                            onChange={(e) =>
                              setSelectedLocation(e.target.value)
                            }
                            className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                          />
                          <span className="ml-2 text-[#17354A]">
                            {location}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Category Filter */}
                  <div>
                    <h3 className="font-medium text-[#17354A] mb-2">Functie</h3>
                    <div className="space-y-2">
                      {categories.map((category) => (
                        <label key={category} className="flex items-center">
                          <input
                            type="radio"
                            name="category"
                            value={category}
                            checked={selectedCategory === category}
                            onChange={(e) =>
                              setSelectedCategory(e.target.value)
                            }
                            className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                          />
                          <span className="ml-2 text-[#17354A]">
                            {category}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Experience Filter */}
                  <div>
                    <h3 className="font-medium text-[#17354A] mb-2">
                      Ervaring
                    </h3>
                    <div className="space-y-2">
                      {experienceLevels.map((level) => (
                        <label key={level} className="flex items-center">
                          <input
                            type="radio"
                            name="experience"
                            value={level}
                            checked={selectedExperience === level}
                            onChange={(e) =>
                              setSelectedExperience(e.target.value)
                            }
                            className="w-4 h-4 text-[#FFD100] border-gray-300 focus:ring-[#FFD100]"
                          />
                          <span className="ml-2 text-[#17354A]">{level}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="pt-4 space-y-4">
                    <button
                      onClick={() => {
                        clearFilters();
                        setIsMobileFiltersOpen(false);
                      }}
                      className="w-full px-4 py-2 text-[#FFD100] border border-[#FFD100] rounded-lg"
                    >
                      Filters wissen
                    </button>
                    <button
                      onClick={() => setIsMobileFiltersOpen(false)}
                      className="w-full px-4 py-2 bg-[#FFD100] text-white rounded-lg"
                    >
                      Toon resultaten
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Job Listings */}
          <div className="flex-1">
            <div className="space-y-6">
              {filteredJobs.length === 0 ? (
                <div className="text-center py-12 bg-[#F8F9FB] rounded-xl">
                  <p className="text-[#17354A] text-lg">
                    Geen vacatures gevonden
                  </p>
                  <button
                    onClick={clearFilters}
                    className="mt-4 text-[#FFD100] hover:underline"
                  >
                    Wis filters
                  </button>
                </div>
              ) : (
                filteredJobs.map((job, index) => (
                  <div key={index} className="group">
                    <div className="border border-[#E5E7EB] rounded-xl p-6 hover:border-[#17354A]/50 transition-colors duration-150 bg-white">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                        <h3 className="font-bold text-[20px] text-[#17354A] mb-2 md:mb-0 group-hover:text-[#FFD100] transition-colors">
                          {job.title}
                        </h3>
                        <div className="flex flex-wrap gap-3">
                          <span className="inline-flex items-center text-[#17354A] text-sm bg-[#F8F9FB] px-3 py-1 rounded-full">
                            <MapPin className="w-4 h-4 mr-1" />
                            {job.location}
                          </span>
                          <span className="inline-flex items-center text-[#17354A] text-sm bg-[#F8F9FB] px-3 py-1 rounded-full">
                            <Clock className="w-4 h-4 mr-1" />
                            {job.type}
                          </span>
                          <span className="inline-flex items-center text-[#17354A] text-sm bg-[#F8F9FB] px-3 py-1 rounded-full">
                            <Briefcase className="w-4 h-4 mr-1" />
                            {job.experience}
                          </span>
                        </div>
                      </div>
                      <p className="text-[#17354A] mb-4">{job.description}</p>
                      <div className="mb-6">
                        <h4 className="font-medium text-[#17354A] mb-2">
                          Vereisten:
                        </h4>
                        <ul className="list-disc list-inside space-y-1">
                          {job.requirements.map((req, reqIndex) => (
                            <li key={reqIndex} className="text-[#17354A]">
                              {req}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div className="text-[#17354A]">
                          <span className="font-medium">
                            Salarisindicatie:{" "}
                          </span>
                          {job.salary} per maand
                        </div>
                        <Link
                          to={`/vacatures/${job.title
                            .toLowerCase()
                            .replace(/ /g, "-")}`}
                          className="inline-flex items-center justify-center px-6 py-2 bg-[#FFD100] text-white rounded-full font-medium hover:bg-[#FFD100]/90 transition-colors group-hover:bg-[#E6B800]"
                        >
                          Solliciteer nu
                          <ChevronRight className="w-4 h-4 ml-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Open Application */}
        <div className="mt-12 bg-[#FFD100] text-white rounded-xl p-8 md:p-12">
          <h2 className="font-bold text-[24px] lg:text-[36px] mb-4">
            Open sollicitatie
          </h2>
          <p className="text-[16px] md:text-[18px] mb-6">
            Staat jouw droombaan er niet tussen? Stuur ons een open
            sollicitatie! We zijn altijd op zoek naar getalenteerde mensen die
            ons team willen versterken.
          </p>
          <Link
            to="/vacatures/open-sollicitatie"
            className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#FFD100] rounded-full font-medium hover:bg-white/90 transition-colors"
          >
            Solliciteer direct
            <ChevronRight className="w-4 h-4 ml-1" />
          </Link>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Vacatures;
